import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store';

export const PrivateRoute: React.FC<{ redirectTo?: string }> = ({ redirectTo = '/' }) => {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const isInitialized = useAppSelector((s) => s.auth.isInitialized);
  const location = useLocation();

  if (!isInitialized) {
    return null;
  }

  if (!isAuthenticated) {
    if (location.pathname === redirectTo) {
      return <Outlet />;
    }

    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

// Gates the Manager Center routes (Availability Approvals, Workforce Intelligence, Reports) on
// the same workforce-intelligence/dashboard access check that drives the sidebar/menu visibility,
// so a user can't reach those pages by typing the URL directly even if the nav item is hidden.
export const ManagerCenterRoute: React.FC<{ redirectTo?: string }> = ({ redirectTo = '/dashboard' }) => {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const isInitialized = useAppSelector((s) => s.auth.isInitialized);
  const hasAccess = useAppSelector((s) => s.managerCenterAccess.hasAccess);
  const isChecked = useAppSelector((s) => s.managerCenterAccess.isChecked);
  const location = useLocation();

  if (!isInitialized || (isAuthenticated && !isChecked)) {
    return null;
  }

  if (!isAuthenticated || !hasAccess) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export const PublicRoute: React.FC<{ redirectTo?: string }> = ({ redirectTo = '/dashboard' }) => {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const isInitialized = useAppSelector((s) => s.auth.isInitialized);
  const location = useLocation();

  if (!isInitialized) {
    return null;
  }

  if (isAuthenticated) {
    if (location.pathname === redirectTo) {
      return <Outlet />;
    }

    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export {};
